<h2 mat-dialog-title>{{ title() }}</h2>

<mat-dialog-content>
  {{ message() }}
</mat-dialog-content>

<mat-dialog-actions>
  <button mat-button mat-dialog-close>Cancel</button>
  <button mat-button mat-dialog-close cdkFocusInitial (click)="confirm()">{{ confirmText() }}</button>
</mat-dialog-actions>